<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <!-- :rules="$text_rules($t('label_company_name'))"  -->
              <mrc_ess_multiText
                :readonly="disabled"
                :isNational="judegNational('org_level_name')"
                style="width:100%"
                :label="$t('label_company_name') + '*'"
                append-icon="mdi-longitude"
                v-model="params.org_level_name"
              >
              </mrc_ess_multiText>
            </v-col>
            <v-col cols="12" sm="6">
              <!-- :rules="$text_rules($t('label_Short_code'))" -->
              <mrc_ess_multiText
                :readonly="disabled"
                :isNational="judegNational('org_level_shortcode')"
                style="width:100%"
                append-icon="mdi-longitude"
                :label="$t('label_Short_code') + '*'"
                v-model="params.org_level_shortcode"
              >
              </mrc_ess_multiText>
            </v-col>
            <v-col cols="12">
              <mrc_ess_autoComplete
                :label="$t('label_The_higher_the_unit')"
                orgView
                :readonly="disabled"
                v-model="params.org_level_code_parent"
                :dropDownList="org_level_code_parent_list"
              >
              </mrc_ess_autoComplete>
              <!--  :prompt_name="companyParent" -->
            </v-col>
            <v-col cols="12">
              <div class="grey lighten-4 pa-6 pb-0">
                <mrc_ess_input
                  :value="org_level_all"
                  :label="$t('label_The_unit_name') + '*'"
                  disabled
                >
                </mrc_ess_input>
              </div>
            </v-col>
            <v-col cols="12">
              <mrc_ess_staffInfo
                v-model="params.org_level_leader_uuid"
                itemText="view_fields"
                itemValue="value_field"
                :readonly="disabled"
                prompt_name="staffs"
                :label="this.$t('label_head')"
              >
              </mrc_ess_staffInfo>
            </v-col>
          </v-row>
        </v-card-text>
        <mrc_ess_submitBtn
          @cancel="cancel"
          :loading="loading"
          v-if="!disabled"
          @success="success"
        ></mrc_ess_submitBtn>
      </v-card>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  get_company_info,
  get_company_update,
  get_company_del,
} from "@/service/api/company_set"
import { getBusinessList } from "@/service/api/prompt"
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      skLoading: true,
      params: {
        uuid: "",
        org_level_name: "",
        org_level_shortcode: "",
        org_level_leader_uuid: "",
        org_level_code_parent: "",
        org_level_all: null,
      },
      org_level_code_parent_list: [],
    }
  },
  validation: {
    params: {
      org_level_name: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      org_level_shortcode: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
    },
  },
  created() {},
  mounted() {
    this.skLoading = true
    this.$nextTick(async () => {
      await this.national("mrbase_sys_org_levels")
      await this.get_info()
      await this.get_org_level_parent_list()
    })
    this.skLoading = false
  },
  methods: {
    async get_org_level_parent_list() {
      let obj = {}
      switch (this.$store.state.userData.userType) {
        case 2:
          obj = {
            // prompt_name: 'org_levels_manager_filter_company_company',
            prompt_name: "org_levels_manager_filter_company_code_update",
            user_id: this.$store.state.userData.user_id,
            org_level_code: this.$store.state.currentCompanyObj.org_level_code,
            uuid: this.$store.state.uuid,
          }
          break
        default:
          obj = {
            prompt_name: "parent_org_level",
            org_level_code: this.$store.state.orgLevelCode,
            client_uuid: this.$store.state.userData.clientUuid,
            user_id: this.$store.state.userData.user_id,
            org_level_code_parent: this.params.org_level_code_parent,
          }
      }
      const res = await getBusinessList(obj)
      if (res.code == 200) {
        this.org_level_code_parent_list = res.data
      }
    },
    // 获取详情
    async get_info() {
      const info = await get_company_info({ uuid: this.$store.state.uuid })
      if (info.code == 200) {
        this.params = Object.assign({}, info.data)
        this.$set(this.params, "org_level_all", info.data.org_level_all)
        this.$store.commit("set_uuid2", this.params.client_uuid)
      }
    },
    cancel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then(async () => {
          // this.$router.push({
          //   name: 'enterprise',
          // })
          await this.get_info()
          // this.disabled = !this.disabled

          this.$emit("cancel", !this.disabled)
        })
        .catch(() => {})
    },
    async success() {
      this.loading = true
      // {
      //   uuid: this.params.uuid,
      //   org_level_name: this.params.org_level_name,
      //   org_level_shortcode: this.params.org_level_shortcode,
      //   org_level_code_parent: this.params.org_level_code_parent,
      //   org_level_leader_uuid: this.params.org_level_leader_uuid,
      //   client_uuid: this.$store.state.uuid2,
      //   org_level_all: this.params.org_level_all,
      //   org_level_code: this.params.org_level_code
      // }
      const update = await get_company_update(this.params)
      if (update.code == 200) {
        this.$Message({ text: this.$t("message_The_operation_was_successful") })
        await this.get_info()
        this.$emit("changeiconStatus")
        // this.disabled = !this.disabled
        if (
          this.$store.state.userData.userType != 1 &&
          this.$store.state.userData.userType != 4
        ) {
          await this.$store.dispatch("set_topcompanylist")
        }
      }
      this.loading = false
    },
    handleReturn() {
      this.$router.go(-1)
    },
    handleEdit() {
      this.disabled = !this.disabled
    },
    // 删除
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      })
        .then(async () => {
          const del = await get_company_del({
            uuid: this.$store.state.listObj.uuid,
          })
          if (del.code == 200) {
            this.delData(this.$store.state.listObj.uuid)
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            })
            if (
              this.$store.state.userData.userType != 1 &&
              this.$store.state.userData.userType != 4
            ) {
              await this.$store.dispatch("set_topcompanylist")
            }
            this.$router.push({
              name: "enterprise",
            })
          }
        })
        .catch(() => {})
      // this.$myConfirm({ content: '是否删除' })
      //   .then(async () => {
      //     const del = await get_company_del({
      //       uuid: this.params.uuid,
      //     })
      //     if (del.code == 200) {
      //       this.$Message({
      //         text: this.$t('message_The_deletion_was_successful'),
      //       })
      //       this.$router.go(-1)
      //     }
      //   })
      //   .catch(() => { })
    },
  },
  computed: {
    org_level_all() {
      return this.INT(this.params.org_level_all)
    },
    companyParent() {
      let obj = {}
      switch (this.$store.state.userData.userType) {
        case 2:
          obj = {
            // prompt_name: 'org_levels_manager_filter_company_company',
            prompt_name: "org_levels_manager_filter_company_code_update",
            user_id: this.$store.state.userData.user_id,
            org_level_code: this.$store.state.currentCompanyObj.org_level_code,
            uuid: this.$store.state.uuid,
          }
          break
        default:
          obj = {
            prompt_name: "parent_org_level",
            org_level_code: this.$store.state.orgLevelCode,
            client_uuid: this.$store.state.userData.clientUuid,
            user_id: this.$store.state.userData.user_id,
            org_level_code_parent: this.params.org_level_code_parent,
          }
      }
      return obj
    },
  },
  watch: {},
}
</script>

<style scoped></style>
